import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { environment } from '../../../environments/environment';
import { BaseService } from '../base.service';
import { Helper } from '../helper.service';
import { ITestRunPatchPayload, ITestRunRowModel } from '../../models/test-runs/test-run-row.model';

@Injectable({
  providedIn: 'root',
})
export class TestRunsApiService extends BaseService {
  constructor(
    private http: HttpClient,
    private helperService: Helper,
  ) {
    super();
  }

  public getTestRuns(nodeId: string, projectId: string, workspaceId: string | null): Observable<ITestRunRowModel[]> {
    if (!nodeId) {
      return of([]);
    }
    const params = new URLSearchParams();
    if (projectId) params.set('projectId', projectId);
    if (workspaceId) params.set('workspaceId', workspaceId);
    const qs = params.toString();
    const url = `${environment.workspaceServiceEndPoint}/GetTestRuns/${encodeURIComponent(nodeId)}${qs ? '?' + qs : ''}`;
    return this.http
      .get(url, {
        headers: this.helperService.getApiAuthHeader(),
        responseType: 'json',
      })
      .pipe(
        map((res: unknown) => (Array.isArray(res) ? (res as ITestRunRowModel[]) : [])),
        catchError((err) => this.helperService.handleError(err)),
      );
  }

  public patchTestRun(nodeId: string, labelId: string, payload: ITestRunPatchPayload): Observable<ITestRunRowModel | null> {
    if (!nodeId || !labelId || !payload) {
      return throwError(() => new Error('patchTestRun called with invalid arguments'));
    }
    const url = `${environment.workspaceServiceEndPoint}/TestRuns/${encodeURIComponent(nodeId)}/${encodeURIComponent(labelId)}`;
    return this.http
      .patch(url, payload, {
        headers: this.helperService.getApiAuthHeader(),
        responseType: 'json',
      })
      .pipe(
        map((res: unknown) => (res as ITestRunRowModel) ?? null),
        catchError((err) => this.helperService.handleError(err)),
      );
  }
}
